import React from 'react';
import { Typography } from 'antd';
import CopyText from '../components/CopyText';
import TimeAgo from '../components/TimeAgo';

const { Text } = Typography;

export const customerDetailsTransactionTable = (offset) => [
    {
        title: "Sr. No.",
        key: 'serial_no',
        className: 'col-index',
        width: 80,
        responsive: ['sm'],
        render: (item, record, index) => <Text>{offset + index+1}</Text>,
    },
    {
        title: 'Transaction Type',
        key: 'transaction_type',
        dataIndex: 'transaction_type',
    },
    {
        title: 'Transaction Amount',
        key: 'transaction_amount',
        dataIndex: 'transaction_amount',
        align: 'right',
        className: 'col-num',
        render: (item) => <Text>{item ? `$${item}` : '--'}</Text>,
    },
    {
        title: 'Transaction ID',
        key: 'transaction_id',
        dataIndex: 'transaction_id',
        className: 'col-mono',
        render: (item) => <CopyText value={item} />,
    },
    {
        title: "Transaction TIme",
        key: "created_at",
        className: 'col-date',
        render: (item) => <TimeAgo value={item && item.created_at} />,
    },
];
